import { FontIcon, ListItem } from 'react-md'
import { useIntl } from 'react-intl'
import type { ReportListItem as ReportListItemType } from './types'

type ReportListItemProps = {
	item: ReportListItemType
	isLast?: boolean
}

const ReportListItem = ({ item, isLast = false }: ReportListItemProps) => {
	const intl = useIntl()
	const { key, title, description, icon } = item
	return (
		<ListItem
			key={key}
			primaryText={
				<h4 style={{ marginTop: 0, marginBottom: 0 }}>{title(intl)}</h4>
			}
			secondaryText={description && description(intl)}
			onClick={() => {}}
			rightIcon={<FontIcon>chevron_right</FontIcon>}
			leftIcon={<FontIcon>{icon}</FontIcon>}
			style={
				isLast
					? {
							height: 64,
					  }
					: {
							borderBottomColor: 'rgba(0,0,0,0.2)',
							borderBottomStyle: 'solid',
							borderBottomWidth: 1,
							height: 64,
					  }
			}
			tileStyle={{
				height: '100%',
			}}
		/>
	)
}

export default ReportListItem
